module.exports = __webpack_public_path__ + "static/media/eclipse-alt.8f9a581f.svg";